module.exports = require('./helpers/bundle-url').getBundleURL('jWbtw') + "DashLogo.ac107e85.svg";